import {IPosition} from "../interfaces/position.interface";

export const getRoute = (item: IPosition) => {
  return `/${item.type.key}/${item.id}`
}